import { css } from "@compiled/react";
import Lottie, { Options, EventListener } from "react-lottie";

import { media } from "@atlaskit/primitives";

export const LottieAnimationContainer = ({
    options,
    eventListener,
    isAnimationBrandRefresh = false
}: {
    options: Options;
    eventListener: EventListener[] | undefined;
    isAnimationBrandRefresh?: boolean;
}) => (
    <div
        css={[
            wireFrameStyle,
            isAnimationBrandRefresh && animationBrandRefreshExpStyle
        ]}
        data-testid="lottie-animation-container"
    >
        <Lottie options={options} eventListeners={eventListener} />
    </div>
);

const wireFrameStyle = css({
    overflow: "hidden",
    zIndex: 1
});

const animationBrandRefreshExpStyle = css({
    height: 500,
    [media.above.sm]: {
        maxHeight: "800px",
        marginBlockStart: "-100px"
    }
});
